import { SessionExpired as SharedSessionExpired } from "@amzn/it-shop-shared-components";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { Paths } from "@/common/paths/paths";
import React from "react";

const MIDWAY_LOGIN_URL = "https://midway-auth.amazon.com/login?reauth=1";

const SessionExpired: React.FC = () => (
  <SharedSessionExpired
    strings={{
      title: getString("sessionExpired.title"),
      description: getString("sessionExpired.description"),
      tryAgainButton: getString("sessionExpired.tryAgainButton"),
      returnHomeButton: getString("sessionExpired.returnHomeButton"),
    }}
    onTryAgain={(returnTo) => {
      const reAuthUrl = returnTo
        ? `${MIDWAY_LOGIN_URL}&returnTo=${encodeURIComponent(returnTo)}`
        : MIDWAY_LOGIN_URL;
      window.location.href = reAuthUrl;
    }}
    onReturnHome={() => {
      window.location.href = Paths.search.url;
    }}
  />
);

export default SessionExpired;
